import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import { getDatesRange, dateFormater } from '../utils';

class PHUTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  setData = () => {
    var lowestDate, highestDate, data;

    var startEndDatesList = (casesList) => {
      Object.keys(casesList).forEach((date) => {
        if (date === 'null') {
          return;
        }
        if (!lowestDate) {
          lowestDate = date;
          highestDate = date;
        }
        if (date < lowestDate) {
          lowestDate = date;
        } else if (date > highestDate) {
          highestDate = date;
        }
      });
    };

    switch (this.props.selectedTab) {
      case 'newCases': {
        data = Object.values(ReducedData.dataPHU)
          .map((item) => {
            startEndDatesList(item.newCases);

            var newItem = { ...item.newCases };

            newItem.name = item.Reporting_PHU;

            return newItem;
          })
          .sort((a, b) => a.name.localeCompare(b.name));
        break;
      }
      case 'totalCases': {
        data = Object.values(ReducedData.dataPHU)
          .map((item) => {
            startEndDatesList(item.newCases);
            let newObject = {};
            let sum = 0;
            Object.keys(item.newCases)
              .sort(function (a, b) {
                return new Date(b) - new Date(a);
              })
              .reverse()
              .forEach((key, i) => {
                sum += item.newCases[key];
                newObject[key] = sum.toLocaleString();
                //debugger
              });
            var newItem = { ...newObject };
            newItem.name = item.Reporting_PHU;
            return newItem;
          })
          .sort((a, b) => a.name.localeCompare(b.name));
        break;
      }
      default:
        break;
    }
    //columns are days

    var dates = getDatesRange(lowestDate, highestDate);
    dates.reverse().unshift('Public Health Unit');
    var columns = dates.map((item, z) => {
      return {
        title: z === 0 ? item : dateFormater(item),
        dataIndex: z === 0 ? 'name' : item + 'T00:00:00',
        key: item.toLocaleString,
        width: z === 0 ? '10%' : '1%',
      };
    });

    this.setState({ data, columns });
  };

  componentDidMount() {
    this.setData();
  }

  render() {
    return (
      <Table
        bordered
        columns={this.state.columns}
        dataSource={this.state.data}
        scroll={{ x: true }}
        pagination={{ pageSize: 4 }}
      />
    );
  }
}

export default PHUTable;
